// extracted by mini-css-extract-plugin
export default {"cls1":"PremiumBadge-cls1_iqa","cls2":"PremiumBadge-cls2__zb PremiumBadge-cls1_iqa"};